export default __webpack_public_path__ + "static/media/lspfotografi.509b58b2.png";